import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import moment from 'moment';

export function timeRangeValidator(
  startTimeKey: string,
  endTimeKey: string,
  dutyType?: string,
  nonCont?: boolean,
  compareKey?: string
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const formGroup = control.parent;
    if (!formGroup) return null;
    const startTimeControl = formGroup.get(startTimeKey);
    const endTimeControl = formGroup.get(endTimeKey);
    const compareControl: any = compareKey ? formGroup.get(compareKey) : null;
    if (!startTimeControl || !endTimeControl) return null;
    const firstSlotStartTime = startTimeControl.value;
    const firstSlotEndTime = endTimeControl.value;
    const compareTimeCtrl: any = compareControl?.value;
    //  Detect if input is in 12-hour format and convert to 24-hour format
    const startTime = moment(
      firstSlotStartTime,
      ['hh:mm A', 'HH:mm'],
      true
    ).format('HH:mm');
    const endTime = moment(firstSlotEndTime, ['hh:mm A', 'HH:mm'], true).format(
      'HH:mm'
    );
    const compare: any = moment(
      compareTimeCtrl,
      ['hh:mm A', 'HH:mm'],
      true
    ).format('HH:mm');
    let start = moment(startTime, 'HH:mm');
    let end = moment(endTime, 'HH:mm');
    let compareTime = moment(compare, 'HH:mm');
    if (dutyType === 'DAY') {
      const dayStart = moment('06:00', 'HH:mm'); // 6:00 AM
      const dayEnd = moment('22:15', 'HH:mm'); // 10:15 PM (22:15 in 24-hour format)
      if (start.isValid() && end.isValid()) {
        if (!start.isBetween(dayStart, dayEnd, undefined, '[]')) {
          return { invalidDaySlot: true };
        }
        else{
          clearErrors(startTimeControl);
        }

        if (!end.isBetween(dayStart, dayEnd, undefined, '[]')) {
          return { invalidDaySlot: true };
        }
        if (end.isSameOrBefore(start)) {
          return { invalidRange: true };
        }  
        else{
          clearErrors(endTimeControl);
        }     
      } 
      else {
        if (start.isValid()) {
          
          if (!start.isBetween(dayStart, dayEnd, undefined, '[]')) {
            return { invalidDaySlot: true };
          }
        }
        if (end.isValid()) {
          if (!end.isBetween(dayStart, dayEnd, undefined, '[]')) {
            return { invalidDaySlot: true };
          }
        }
      }

      if (nonCont === true) {
        if (compareTime.isValid()) {
          if (compareTime.isSameOrAfter(end)) {
            return { sameAsFirstSlotEndTime: true };
          }
        }
      } else {
      }
      // clearErrors(startTimeControl, endTimeControl);
      return null;
    } else if (dutyType === 'NIGHT') {
      const nightShiftStart = moment('21:00', 'HH:mm');
      const nightShiftEnd = moment('08:01', 'HH:mm');
      const endLimit = moment('08:00', 'HH:mm').add(1, 'day'); // 08:00 next day
      if (
        start.isSameOrAfter(moment('00:00', 'HH:mm')) &&
        start.isBefore(nightShiftStart)
      ) {
        start = moment(startTime, 'HH:mm').add(1, 'day');
      }
      if (
        end.isSameOrAfter(moment('00:00', 'HH:mm')) &&
        end.isBefore(nightShiftStart)
      ) {
        end = moment(endTime, 'HH:mm').add(1, 'day');
      }
      if (nonCont === true) {
        if (compareTime.isValid()) {
          if (
            compareTime.isSameOrAfter(moment('00:00', 'HH:mm')) &&
            compareTime.isBefore(nightShiftStart)
          ) {
            compareTime = moment(startTime, 'HH:mm').add(1, 'day');
          }
          if (compareTime.isSameOrAfter(end)) {
            return { invalidRange: true };
          }
        }
      }
      if (
        start.isSameOrAfter(moment('00:00', 'HH:mm')) &&
        start.isBefore(nightShiftStart)
      ) {
        if (start.isAfter(end)) {
          return { invalidRange: true };
        }
      }
      if (
        end.isSameOrAfter(moment('00:00', 'HH:mm')) &&
        end.isBefore(nightShiftStart)
      ) {
        if (end.isBefore(start)) {
          return { invalidRange: true };
        }
      }
      if (start.isBefore(nightShiftStart)) {
        return { invalidNightSlot: true };
      }
      if (start.isAfter(endLimit)) {
        return { invalidNightSlot: true };
      }
      if (end.isBefore(nightShiftStart)) {
        return { invalidNightSlot: true };
      }
      if (end.isAfter(endLimit)) {
        return { invalidNightSlot: true };
      }
      if (end.isSameOrBefore(start)) {
        return { invalidRange: true };
      }
      clearErrors(startTimeControl, endTimeControl);
      return null;
    }
    clearErrors(startTimeControl, endTimeControl);
    return null;
  };
}

function isSameAsFirstSlotEndTime(endTime: string, compareTime: string) {
  return endTime !== '' && compareTime !== '' && endTime <= compareTime;
}

function isValidRange(startTime: string, endTime: string) {
  return startTime !== '' && endTime !== '' && startTime < endTime;
}

function isInvalidRange(startTime: string, endTime: string) {
  return startTime !== '' && endTime !== '' && startTime >= endTime;
}

function setError(control: AbstractControl, error: { [key: string]: boolean }) {
  control.setErrors(error);
}

function clearErrors(...controls: AbstractControl[]) {
  controls.forEach((control) => control.setErrors(null));
}
export function halfDaySlotValidator(
  shiftType: 'FIRST_HALF_DAY_DUTY' | 'SECOND_HALF_DAY_DUTY',
  fullDayShift: any,
  dutyType: string,
  isNonCont: boolean,
  breakMinutes: number,
  shifts: any[],
  controlName: string
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control?.parent || dutyType !== 'DAY' || !fullDayShift) return null;

    const formGroup = control.parent;

    const startControl =
      shiftType === 'FIRST_HALF_DAY_DUTY'
        ? formGroup.get('firstSlotStartTime')
        : formGroup.get('secondSlotStartTime');

    const endControl =
      shiftType === 'FIRST_HALF_DAY_DUTY'
        ? formGroup.get('firstSlotEndTime')
        : formGroup.get('secondSlotEndTime');

    const start = moment(startControl?.value, 'HH:mm', true);
    const end = moment(endControl?.value, 'HH:mm', true);

    if (!start.isValid() || !end.isValid()) return null;

    // ========== CONTINUOUS ==========
    if (!isNonCont) {
      const fullStart = moment(fullDayShift.firstSlotStartTime, 'HH:mm');
      const fullEnd = moment(fullDayShift.firstSlotEndTime, 'HH:mm');
      const totalMs = fullEnd.diff(fullStart) - breakMinutes * 60 * 1000;
      const halfMs = totalMs / 2;

      if (shiftType === 'FIRST_HALF_DAY_DUTY') {
        const maxEnd = moment(fullStart).add(halfMs, 'ms');

        if (start.isBefore(fullStart)) return { startTooEarly: true };
        if (end.isAfter(maxEnd)) return { endTooLate: true };
      }

      if (shiftType === 'SECOND_HALF_DAY_DUTY') {
        const maxStart = moment(fullStart).add(halfMs, 'ms');
        const fullSlotEnd = moment(fullDayShift.firstSlotEndTime, 'HH:mm');

        if (end.isAfter(fullSlotEnd)) return { endTooLate: true };
        if (start.isBefore(maxStart)) return { startTooEarly: true };
      }
    }

    // ========== NON-CONTINUOUS ==========
    if (isNonCont) {
      if (shiftType === 'FIRST_HALF_DAY_DUTY') {
        const fullStart = moment(fullDayShift.firstSlotStartTime, 'HH:mm');
        const fullEnd = moment(fullDayShift.firstSlotEndTime, 'HH:mm');
        if (start.isBefore(fullStart)) return { startTooEarly: true };
        if (end.isAfter(fullEnd)) return { endTooLate: true };
      }

      if (shiftType === 'SECOND_HALF_DAY_DUTY') {
        const fullStart = moment(fullDayShift.secondSlotStartTime, 'HH:mm');
        const fullEnd = moment(fullDayShift.secondSlotEndTime, 'HH:mm');
        if (start.isBefore(fullStart)) return { startTooEarly: true };
        if (end.isAfter(fullEnd)) return { endTooLate: true };
      }
    }

    // ========== CROSS SHIFT DEPENDENCIES ==========
    if (shiftType === 'SECOND_HALF_DAY_DUTY' && controlName === 'secondSlotStartTime') {
      const firstHalf = shifts.find(s => s.shiftType === 'FIRST_HALF_DAY_DUTY');
      if (firstHalf?.firstSlotEndTime) {
        const firstHalfEnd = moment(firstHalf.firstSlotEndTime, 'HH:mm');
        if (start.isBefore(firstHalfEnd)) return { startsBeforeFirstHalfEnds: true };
      }
    }

    if (shiftType === 'FIRST_HALF_DAY_DUTY' && controlName === 'firstSlotEndTime') {
      const secondHalf = shifts.find(s => s.shiftType === 'SECOND_HALF_DAY_DUTY');
      if (secondHalf?.secondSlotStartTime) {
        const secondHalfStart = moment(secondHalf.secondSlotStartTime, 'HH:mm');
        if (end.isAfter(secondHalfStart)) return { endsAfterSecondHalfStarts: true };
      }
    }

    if (end.isBefore(start)) {
      return { invalidRange: true };
    }

    return null;
  };
}
